import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { isFlashAdmin } from '../../utils/adminAccess';
import {
  adminDashboardTabHref,
  adminDashboardTabItems,
  parseAdminDashboardTab,
} from '../../utils/adminDashboardTabs';

const AdminDashboardTabNav: React.FC = () => {
  const { user } = useAuth();
  const [searchParams] = useSearchParams();
  const activeTab = parseAdminDashboardTab(searchParams);
  const tabs = adminDashboardTabItems();

  if (!isFlashAdmin(user)) {
    return null;
  }

  return (
    <div className="border-t border-gray-200 bg-white">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <nav
          className="-mb-px flex space-x-6 overflow-x-auto"
          aria-label="Admin dashboard"
        >
          {tabs.map(({ key, label }) => {
            const isActive = activeTab === key;
            return (
              <Link
                key={key}
                to={adminDashboardTabHref(key)}
                className={`whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm ${
                  isActive
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                {label}
              </Link>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default AdminDashboardTabNav;
